import { render, staticRenderFns } from "./OpenInNew.vue?vue&type=template&id=f2034556&"
import script from "./OpenInNew.vue?vue&type=script&lang=js&"
export * from "./OpenInNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports